import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieBanner.vue?vue&type=style&index=0&id=af140ae4&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af140ae4"]])

export default __exports__